import React, { memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Tooltip } from '@mui/material';
import { ArrowIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { COMPOSED_CLAIMS } from 'constants/composedClaims';
import { IconDirection } from 'constants/coreDesignSystem';

import { selectIsClaimAllowed } from 'store/auth/selectors';
import { escalateTpoChatAction } from 'store/teamChat/actions';

import {
  ESCALATE_TPO_CHAT_LABEL,
  ESCALATE_TPO_CHAT_TOOLTIP,
} from '../../LoanEditorChatDrawer.constants';

import { escalateButtonIconStyles } from './EscalateTpoChatControl.styles';
import { EscalateTpoChatControlTestIds } from './EscalateTpoChatControl.testIds';

const EscalateTpoChatControl = memo(({ chatId }) => {
  const dispatch = useDispatch();

  const isEscalateAllowed = useSelector(selectIsClaimAllowed(COMPOSED_CLAIMS.TPO_CHAT_ESCALATE));

  const [isEscalating, setIsEscalating] = useState(false);

  const onEscalate = useCallback(async () => {
    if (!chatId || isEscalating) {
      return;
    }

    setIsEscalating(true);

    try {
      await dispatch(escalateTpoChatAction({ chatId }));
    } finally {
      setIsEscalating(false);
    }
  }, [chatId, isEscalating, dispatch]);

  if (!isEscalateAllowed || !chatId) {
    return null;
  }

  return (
    <Tooltip placement="bottom" title={ESCALATE_TPO_CHAT_TOOLTIP}>
      <span>
        <Button
          data-testid={EscalateTpoChatControlTestIds.ESCALATE_BUTTON}
          disabled={isEscalating}
          size="small"
          startIcon={<ArrowIcon direction={IconDirection.UP} style={escalateButtonIconStyles} />}
          variant="contained"
          onClick={onEscalate}
        >
          {ESCALATE_TPO_CHAT_LABEL}
        </Button>
      </span>
    </Tooltip>
  );
});
EscalateTpoChatControl.propTypes = {
  chatId: PropTypes.string,
};

export default EscalateTpoChatControl;
